interface TiptapTextNode {
  type: string;
  text?: string;
}

interface TiptapNode {
  type: string;
  content?: TiptapTextNode[];
}

interface TiptapDoc {
  type: 'doc';
  content?: TiptapNode[];
}

export function isRichTextContentEmpty(content: TiptapDoc | null | undefined): boolean {
  if (!content || typeof content !== 'object') return true;

  if (!Array.isArray(content.content) || content.content.length === 0) {
    return true;
  }

  return content.content.every((node: TiptapNode) => {
    if (node.type !== 'paragraph') return false;

    return !node.content || node.content.every(child => !child.text || !child.text.trim());
  });
}
